import { Typography } from "@mui/material";
import { IDisplayTextProps } from "../types/interfaces/IDisplayTextProps";

//This component is responsible for rendering the display text for competencies. 
const DisplayTextWithWrap: React.FC<IDisplayTextProps> = ({ isParent, displayText }) =>  {
    return (
        <>
            <Typography 
                color={ isParent ? 'black' : 'inherit' } 
                sx={{
                     mr: 1, 
                     fontWeight: isParent ? 'bold' : 'normal', 
                     flexGrow: 1, 
                     marginRight: 2
                }}>{displayText}</Typography>
        </>
    );
}

export default DisplayTextWithWrap;